import React from 'react';
import { CheckIcon } from 'lucide-react';
export function FeaturesList() {
  const features = ['BIO-Proteine in optimaler Zusammensetzung - Erbse, Kürbis, Reis & Sonnenblume für perfekte Aminosäuren', 'Spezieller Mikronährstoff-Komplex für Frauen - B-Vitamine, Bromelain & wertvolle Pflanzenextrakte', 'Natürlich sättigend - Ballaststoffe aus Inulin, Pektin & Flohsamenschalen halten dich angenehm satt', '100% natürliche Zutaten - Echte Vanille, natürliche Aromen, ohne künstliche Süßstoffe', 'Hautfreundlich dank Bromelain - Unterstützt Kollagenproduktion und verbesserte Proteinaufnahme', 'Wissenschaftlich entwickelt - Von Ökotrophologen in Deutschland formuliert', 'Umweltfreundlich & vegan - DHL Go Green Versand, BIO-zertifizierte Proteinrohstoffe, ohne Soja, nachhaltig produziert und verpackt'];
  return <section className="py-8 bg-gray-50" data-id="element-102">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-103">
        <div className="text-center mb-8" data-id="element-104">
          <h3 className="text-4xl font-bold text-gray-800" data-id="element-105">
            Premium Proteine mit Mikronährstoff-Komplex
          </h3>
          <p className="text-gray-600 mt-2" data-id="element-106">
            Hochwertige Inhaltsstoffe für optimale Ergebnisse
          </p>
          <div className="flex justify-center mt-8 mb-10" data-id="element-107">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oEaEZcnKS89wV6jbeS7Ky5/Screenshot_2025-10-14_at_13.27.38.png" alt="Premium Proteinpulver mit Mikronährstoff-Komplex Diagram" className="max-w-full md:max-w-2xl rounded-lg shadow-sm" data-id="element-108" />
          </div>
        </div>
        <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-sm" data-id="element-109">
          <div className="grid md:grid-cols-2 gap-4" data-id="element-110">
            {features.map((feature, index) => <div key={index} className="flex items-start" data-id="element-111">
                <div className="flex-shrink-0 w-6 h-6 bg-emerald-600 rounded text-white flex items-center justify-center mt-1" data-id="element-112">
                  <CheckIcon className="h-4 w-4" data-id="element-113" />
                </div>
                <p className="ml-3 text-gray-700" data-id="element-114">{feature}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}